import { render, staticRenderFns } from "./LoadProfileDetails.vue?vue&type=template&id=479ffd19&scoped=true"
import script from "./LoadProfileDetails.vue?vue&type=script&lang=js"
export * from "./LoadProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./LoadProfileDetails.vue?vue&type=style&index=0&id=479ffd19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ffd19",
  null
  
)

export default component.exports